import { useMutation, useQueryClient } from '@tanstack/react-query';

import { markAllNotificationsAsRead } from '../api/notifications.api';

/**
 * Hook for marking all notifications as read.
 */
export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      // Invalidate notifications queries to refetch with updated read status
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
